import React from "react";
import { useNavContext } from "../../context-api/nav-context";

const BoilerIntro = () => {
  const { closeNavbarMenu } = useNavContext();
  return (
    <section className="intro" onMouseOver={closeNavbarMenu}>
      <div className="section-wrapper">
        <div className="content-container">
          <h2 className="title">Replace Your Old Boiler The AquaHeat Way</h2>
          <p className="subtitle">
            Here at AquaHeat we don't use salesmen. We believe you should be
            able to get a fixed price without any hassel. Get an instant quote
            by answering a few questions about your home. Our professional
            engineers will fit your boiler hassle & mess free.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BoilerIntro;
